import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgStarOutline = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M8.228 7.833a.48.48 0 0 1-.36.257L.412 9.148a.48.48 0 0 0-.262.823l5.376 5.082a.48.48 0 0 1 .143.432l-1.271 7.193a.48.48 0 0 0 .69.51l6.694-3.416a.48.48 0 0 1 .436 0l6.694 3.417a.48.48 0 0 0 .69-.51l-1.271-7.194a.48.48 0 0 1 .143-.432l5.375-5.082a.48.48 0 0 0-.262-.823L16.133 8.09a.48.48 0 0 1-.36-.257l-3.345-6.577a.48.48 0 0 0-.854 0zM12 4.646 9.937 8.702a2.4 2.4 0 0 1-1.8 1.287l-4.501.638 3.207 3.033c.586.554.854 1.365.714 2.159l-.768 4.349 4.121-2.104a2.4 2.4 0 0 1 2.18 0l4.121 2.104-.768-4.35a2.4 2.4 0 0 1 .713-2.158l3.208-3.033-4.502-.638a2.4 2.4 0 0 1-1.8-1.287z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgStarOutline);
export default Memo;
